import type { CSSProperties } from 'react';
import { shareOnScale, type ValueScale } from '../ColumnChart/chart-scale.ts';
import styles from './Chart.module.css';

const heightAt = (share: number): CSSProperties => ({ '--chart-at': String(share) }) as CSSProperties;

export const ValueTicks = ({
  scale,
  formatTick,
}: {
  scale: ValueScale;
  formatTick: (value: number) => string;
}) => (
  <div className={styles['ticks']} aria-hidden="true">
    {scale.ticks.map((tick) => (
      <span key={tick} style={heightAt(shareOnScale(scale, tick))}>
        {formatTick(tick)}
      </span>
    ))}
  </div>
);

export const Gridlines = ({ scale }: { scale: ValueScale }) =>
  scale.ticks.map((tick) => (
    <span
      key={tick}
      className={styles['gridline']}
      data-baseline={tick === 0 ? true : undefined}
      style={heightAt(shareOnScale(scale, tick))}
      aria-hidden="true"
    />
  ));
